export default "__VITE_ASSET__CF7t4GYH__"